var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddPatientInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0.38 201 214.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.9 214.6c45.563 0 82.5-36.937 82.5-82.5s-36.937-82.5-82.5-82.5-82.5 36.937-82.5 82.5 36.937 82.5 82.5 82.5Z",
    strokeOpacity: 0.3,
    stroke: "#33b1ff",
    strokeWidth: 0.8,
    strokeDasharray: 4.828
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    opacity: 0.2,
    d: "M30.496 14.356h152.792v97.188H30.496z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M0 .384h175.22v99.524H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.868 14.872h171.016v82.704H1.868z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M14 22h59.34v62.612H14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33b1ff",
    d: "M15.42 23.28h56.072v59.808H15.42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.116 46.896c-.44-3.552-1.044-7.124-2.4-10.436-1.356-3.312-3.544-6.376-6.584-8.264a7.524 7.524 0 0 0-3.64-1.26c-2.4-.084-4.58 1.52-5.808 3.564a16.628 16.628 0 0 0-1.084 2.204 5.132 5.132 0 0 0-4.26 4.7 13.088 13.088 0 0 0 1.852 24.712v2.232a13.136 13.136 0 0 0-9.812 12.668v6.076h26.168v-6.076a13.136 13.136 0 0 0-9.812-12.668v-2.232a13.088 13.088 0 0 0 9.812-12.672v-.092l1.472 3.276c1.4 3.12 2.836 6.472 2.292 9.848 2.68-4.592 2.456-10.292 1.804-15.58Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33b1ff",
    d: "M1.868 2.256h171.016v12.616H1.868z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.3,
    fill: "#33b1ff",
    d: "M94 41h64.948v4.204H94zm0 18h64.948v4.204H94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c1e7ff",
    d: "M94 50h38.316v4.204H94z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.3,
    fill: "#33b1ff",
    d: "M94 67h26.168v4.204H94zm30.756.436h26.168v4.204h-26.168z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    opacity: 0.2,
    d: "M30.496 147.804h153v54.1h-153z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M2 136h173v57.604H2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.464 137.952h169v53.7h-169z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#f5f5f5",
    cx: 34.12,
    cy: 165.12,
    r: 20.12
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#33b1ff",
    cx: 34.12,
    cy: 165.12,
    r: 17.884
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m41.928 154.952-10.352 13.564-5.776-4.408-2.996 3.924 7.744 5.912.02-.028 1.96 1.496 13.328-17.464z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c1e7ff",
    d: "M71.824 151.392h31.856v5.588H71.824zm0 10.616h87.74v5.588h-87.74zm0 10.62h87.74v5.588h-87.74z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPatientInfo);
export default __webpack_public_path__ + "static/media/add-patient-info.c03b0d977e001620f704fb72dcd77ced.svg";
export { ForwardRef as ReactComponent };